document.addEventListener("DOMContentLoaded", function () {
  const currencySelector = document.querySelector(".currencies"); // Dropdown
  const priceItems = document.querySelectorAll(
    ".price-item, .price-item.price-item--regular.testsherwin"
  ); // Price elements

  let exchangeRates = {}; // Placeholder for dynamic rates

  console.log(priceItems);

  // Helper: Format price for display
  function formatPrice(amount, currency) {
    const symbols = {
      USD: "USD $", // United States Dollar
      EUR: "€", // Euro
      GBP: "£", // British Pound
      CAD: "CAD $", // Canadian Dollar
      AUD: "AUD $", // Australian Dollar
      INR: "₹", // Indian Rupee
      JPY: "¥", // Japanese Yen
      CNY: "¥", // Chinese Yuan
      CHF: "CHF", // Swiss Franc
      SEK: "kr", // Swedish Krona
      NZD: "NZ $", // New Zealand Dollar
    };
    return `${symbols[currency] || currency} ${amount.toFixed(2)}`;
  }

  // Fetch live exchange rates
  async function fetchExchangeRates() {
    const apiKey = "726df80a52734960bbe2500e54a4b870"; // Replace with your Open Exchange Rates API key
    const apiUrl = `https://openexchangerates.org/api/latest.json?app_id=${apiKey}&base=USD`; // Adjust base currency

    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      exchangeRates = data.rates;
      console.log("Exchange rates fetched:", exchangeRates);

      populateCurrencyAttributes();
      setInitialCurrency();
    } catch (error) {
      console.error("Error fetching exchange rates:", error);
    }
  }

  // Populate data-currency-* attributes
  function populateCurrencyAttributes() {
    priceItems.forEach((item) => {
      const basePrice = parseFloat(item.getAttribute("data-base-price"));
      if (isNaN(basePrice)) {
        console.warn(`Invalid base price for element:`, item);
        return;
      }
      Object.keys(exchangeRates).forEach((currency) => {
        const convertedPrice = basePrice * exchangeRates[currency];
        item.setAttribute(
          `data-currency-${currency}`,
          formatPrice(convertedPrice, currency)
        );
      });
    });
  }

  // Handle currency change
  currencySelector.addEventListener("change", function (event) {
    const selectedCurrency = event.target.value;
    // Save the selected currency in local storage
    localStorage.setItem("selectedCurrency", selectedCurrency);
    updatePrices(selectedCurrency);
  });

  // Update prices based on the selected currency
  function updatePrices(selectedCurrency) {
    priceItems.forEach((item) => {
      const newPrice = item.getAttribute(`data-currency-${selectedCurrency}`);
      if (newPrice) {
        item.textContent = newPrice;
        item.setAttribute("data-currency", selectedCurrency);
      } else {
        console.warn(`Price not available for currency: ${selectedCurrency}`);
        item.textContent = "Price not available";
      }
    });
  }

  // Set the initial currency based on the dropdown value or local storage
  function setInitialCurrency() {
    let selectedCurrency = localStorage.getItem("selectedCurrency") || "USD"; // Default to USD if not found
    console.log("Setting initial currency:", selectedCurrency);
    // Ensure the dropdown reflects the selected currency
    if (currencySelector) {
      currencySelector.value = selectedCurrency;
    }
    updatePrices(selectedCurrency);
  }

  // Fetch exchange rates and initialize on page load
  fetchExchangeRates();

  // Improved listener for cart updates
  document.addEventListener("cart:updated", function () {
    console.log("Cart updated, reinitializing prices");
    const selectedCurrency = localStorage.getItem("selectedCurrency") || "USD";
    currencySelector.value = selectedCurrency;
    populateCurrencyAttributes();
    updatePrices(selectedCurrency);
  });

  // Debugging: Catch any other events related to the cart and log
  document.addEventListener("cart:refresh", function () {
    console.log("Cart refreshed, reinitializing prices");
  });
});
